import axios from 'axios'

export class TransactionAPI {
  baseURL = process.env.VUE_APP_ROOT_API
  standaloneURL = process.env.VUE_APP_STANDALONE_API
  constructor (config) {
    this.instance = axios.create({ baseURL: this.baseURL, ...config })
    this.standalone = axios.create({ baseURL: this.standaloneURL })
  }
  setAuthorization (keyword, key) {
    this.instance.defaults.headers.Authorization = `${keyword} ${key}`
  }
  createTransaction (params) {
    return this.standalone.post('/transaction', params)
      .then((response) => response.data)
  }
  getTransaction (id) {
    const url = `/transactions/${id}/?expand=quote,creditor,debtor,owner,policy`
    return this.instance.get(url).then(response => response.data)
  }
  patchTransaction (id, params) {
    const url = `/transactions/${id}/`
    return this.instance.patch(url, params).then(response => response.data)
  }
  checkUnderwriting (params) {
    return this.standalone.post('/uw_check', params)
      .then(response => response.data)
  }
  getQuote (params) {
    return this.instance.post('/quotes/', params)
      .then(response => response.data)
  }
  payPolicy (params) {
    return this.instance.post('/policies/', params)
      .then(response => response.data)
  }
  registerCustomer (params) {
    return this.instance.post('/auth/registration/customer/', params)
      .then((response) => response.data)
  }
  setOwner (params) {
    return this.standalone.post('/owner', params)
      .then((response) => response.data)
  }
}
const transactionAPI = new TransactionAPI()
export default transactionAPI
